import axios from "axios";
import { ACCESS_TOKEN_KEY } from "../helpers/constants";

const { REACT_APP_ENV, REACT_APP_PROD_API_HOST, REACT_APP_DEV_API_HOST } =
  process.env;

const api = axios.create({
  baseURL:
    REACT_APP_ENV === "production"
      ? REACT_APP_PROD_API_HOST
      : REACT_APP_DEV_API_HOST,
});

api.interceptors.request.use(
  async (config) => {
    if (
      config.url &&
      (config.url === "/api/v2/app/auth" ||
        config.url === "/api/v2/app/cliente/redefinir-senha/solicitar" ||
        config.url === "/api/v2/app/cliente/redefinir-senha/validar" ||
        config.url === "/api/v2/config?app" ||
        config.url === "/api/v2/app/cliente/redefinir-senha" ||
        config.url.startsWith("/api/v2/app/cliente/verificacao") ||
        (config.url === "/api/v2/app/cliente" &&
          config.method &&
          config.method === "post") ||
        (config.url.startsWith("/api/v2/app/plano/") &&
          config?.method === "get"))
    ) {
      return config;
    }

    const token: string | null = localStorage.getItem(ACCESS_TOKEN_KEY);

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem(ACCESS_TOKEN_KEY);

      if (error?.config?.url !== "/api/v2/app/auth") {
        window.location.href = "/login";
      }
    }

    const message =
      "Um erro inesperado aconteceu. Se o erro persistir, entre em contato com o suporte.";

    if (error.response) {
      return Promise.reject({
        ...error?.response?.data,
        message: error?.response?.data?.message || message,
        status: error.response.status,
      });
    }

    return Promise.reject({
      message,
      code: error?.code,
    });
  }
);

export default api;
